<template>
  <div class="login-page">
      <div class="container h-100">
          <div class="row align-items-center h-100">
              <div class="col-4"></div>
              <div class="col-4">
                <div class="card text-center d-xl-block">
                    <center><img class="my-4" src="logo.png" width="150"></center>
                    <h4 class="mb-4">{{ tt('reset_password') }}</h4>                                      
                      <div class="input-group input-group-lg style-input">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></div>
                          </div>
                          <input id="name" type="text" class="form-control" :placeholder="tt('email')" autofocus="" autocomplete="off" v-model="email" v-on:keyup.enter="resetPassword">
                      </div>  
                      <div class="input-group input-group-lg pt-3 style-input">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></div>
                          </div>
                          <input id="name" type="password" class="form-control" :placeholder="tt('password')" autofocus="" autocomplete="off" v-model="password" v-on:keyup.enter="resetPassword">
                      </div>
                      <div class="input-group input-group-lg pt-3 style-input">
                          <div class="input-group-prepend">
                            <div class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></div>
                          </div>
                          <input id="name" type="password" class="form-control" :placeholder="tt('password_confirmation')" autofocus="" autocomplete="off" v-model="password_confirmation" v-on:keyup.enter="resetPassword">
                      </div>                    
                      <p class="pt-3">
                        <button type="button" class="btn btn-sm btn-lg btn-login" style="background: linear-gradient(to left, #2e41db, #5626c7);padding-right: 40px;padding-left: 40px;color: #fff;outline-color: black;" v-on:click="resetPassword()" :disabled="btnLogin.onLoading">
                          <span v-if="btnLogin.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                          <span v-else>{{ tt('reset_password') }}</span>
                        </button>
                      </p>                      
                      <router-link to="/login" class="py-4" tag="p"><a href="">{{ tt('back_to_login') }}</a></router-link>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
  import {mapActions} from 'vuex'
  import router from '@/routes/router'
  import Api from '@/helpers/api';
  import authService from '@/services/auth.service';

  
  export default {
    data() {
      return {        
        btnLogin: {
          onLoading: false
        },
        email: '',                 
        password: '',                 
        password_confirmation: '',                 
        token: this.$route.params.token,                 
      };
    }, 
    methods: {
      resetPassword() {          
        let context = this;        
        if (this.email) {
          this.btnLogin.onLoading = true;

          Api(context, authService.resetPassword(context.email, context.password, context.password_confirmation, context.token)).onSuccess(function(response) {
              context.$notify({
                  message: response.data.message,                                 
                  type: 'success',
                  verticalAlign: 'bottom', 
                  horizontalAlign: 'left'
              });
              context.email = '';     
              context.password = '';     
              context.password_confirmation = '';     
              context.btnLogin.onLoading = false;  
              context.$router.push({ path: '/login'});
            }).onError(function(error) {
              var response = error.response;
              context.alertDialog('error', response.data.message != undefined ? response.data.message : 'The email must be a valid email address or The password confirmation does not match.');
              context.btnLogin.onLoading = false;
            })
            .call()
        } else {
          this.alertDialog('error', this.tt('error_email_required'));
        }
      }
    },
  }
</script>